import { SearchAndCourseFeatureFacade } from '../../search_and_add_courses/facades/search_and_courses_feature_facade';
import { IApplicationConfiguration } from '../../interfaces/scheduler_interfaces';
import { BackToPlannerHelper } from './helpers/back_to_planner_helper';
class BackToPlanner {
  constructor(
    private $state: ng.ui.IStateService,
    private ngSearchAndCourseFeatureFacade: SearchAndCourseFeatureFacade,
    private appConfigModel: IApplicationConfiguration,
    private ngBackToPlannerHelper: BackToPlannerHelper
  ) {}

  goBackToMyPlan() {
    this.ngBackToPlannerHelper.navigateToPlanner();
  }
}

angular.module('capability-ng-scheduler').component('backToPlanner', {
  templateUrl: 'capability-ng-scheduler/src/components/back_to_planner/back_to_planner.html',
  controller: BackToPlanner
});



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/components/back_to_planner/back_to_planner.ts